import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { useSettings } from 'context/SettingsContext';
import { useToast } from 'context/ToastContext';
import * as apiObject from 'api/apiObjects';
import { hidesPurchasePrices } from 'utils/helpers/access/hasUserAccess';
import vconst from 'utils/helpers/structs/vconst';
import { useObjectCard } from '../../context/ObjectCardProvider';
import ChangePriceSaleForm, {
    type ChangePriceSaleValues,
} from '../../ChangePriceSale/ChangePriceSaleForm';
import { getExpendIncomeStatus, type ExpendTeamRow } from '../model';

interface TabPriceProps {
    expendId: number;
    expend: ExpendTeamRow;
    onSaved: () => Promise<void> | void;
}

const TabPrice = ({ expendId, expend, onSaved }: TabPriceProps) => {
    const { t } = useTranslation(['Objects']);
    const { showToast } = useToast();
    const { auth } = useAuth();
    const { localSettings } = useSettings();
    const { isEditLocked } = useObjectCard();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const hidePurchase = hidesPurchasePrices(auth?.user);
    const incomeStatus = getExpendIncomeStatus(expend);
    const readOnly = incomeStatus !== vconst.incomeStatActive || Boolean(isEditLocked);
    const price = Number(expend?.income_price ?? expend?.incomePrice ?? expend?.income_amount ?? 0);
    const priceSale = Number(expend?.income_price_sale ?? expend?.incomePriceSale ?? 0);

    const handleSubmit = async (values: ChangePriceSaleValues) => {
        const resChangePrice = await apiObject.setExpendTeamPriceSale(expendId, {
            price: Number(values.price ?? 0),
            priceSale: Number(values.priceSale ?? 0),
        });
        await onSaved();
        if (resChangePrice) showToast(t('messPriceChanged'), 'success');
        else showToast(t('common:messError'), 'danger');
    };

    return (
        <ChangePriceSaleForm
            variant="tab"
            price={price}
            priceSale={priceSale}
            rate={rate}
            hidePurchase={hidePurchase}
            readOnly={readOnly}
            onSubmit={handleSubmit}
        />
    );
};

export default TabPrice;
